import React from 'react'
import { useFormContext } from 'react-hook-form'

import type { ToolConfig, ToolInput } from 'data/hooks/agents/types'

import { Box } from 'ui/components/Box'
import { Field } from 'ui/components/Field'
import { Input } from 'ui/components/Input'
import { Headline } from 'ui/components/Text'

type ConfigureToolFormInputsProps = {
    inputs: ToolInput[]
}

export const ConfigureToolFormInputs: React.FC<ConfigureToolFormInputsProps> = ({ inputs }) => {
    if (inputs.length < 1) return null

    return (
        <Box flex column gap="m">
            <Headline size="2xs">Default Input Values</Headline>
            {inputs.map((input) => (
                <ToolInputControl key={input.name} input={input} />
            ))}
        </Box>
    )
}

type ToolInputControlProps = {
    input: ToolInput
}

const ToolInputControl: React.FC<ToolInputControlProps> = ({ input }) => {
    const { register } = useFormContext<ToolConfig>()

    return (
        <Field label={input.display_name} shrink>
            <Input placeholder={input.description} {...register(`supplied_inputs.${input.name}`)} />
        </Field>
    )
}
